var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"chart"},[_c('LineChartGenerator',{staticClass:"line-chart",attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }